import { render, staticRenderFns } from "./ownership-cost.vue?vue&type=template&id=315f3312&scoped=true"
import script from "./ownership-cost.vue?vue&type=script&lang=js"
export * from "./ownership-cost.vue?vue&type=script&lang=js"
import style0 from "./ownership-cost.vue?vue&type=style&index=0&id=315f3312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315f3312",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TippyQuestion: require('/var/www/components/tippy/tippy-question.vue').default})
